import React from 'react';
import AdminLayout from '../../components/AdminLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faEnvelope, faRobot, faShieldHalved } from '@fortawesome/free-solid-svg-icons';

const InfoRow: React.FC<{ label: string; value: React.ReactNode; muted?: boolean }> = ({ label, value, muted }) => (
  <div className="flex items-start justify-between py-3 border-b border-gray-100 last:border-b-0">
    <span className="text-sm text-gray-600">{label}</span>
    <span className={`text-sm font-medium ${muted ? 'text-gray-400 italic' : 'text-gray-900'} text-right max-w-[60%] truncate`}>{value}</span>
  </div>
);

const Section: React.FC<{ icon: any; title: string; subtitle?: string; children: React.ReactNode }> = ({ icon, title, subtitle, children }) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200">
    <div className="p-6 border-b border-gray-200 flex items-start gap-4">
      <div className="p-3 bg-gray-50 rounded-lg">
        <FontAwesomeIcon icon={icon} className="w-5 h-5 text-gray-600" />
      </div>
      <div>
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
      </div>
    </div>
    <div className="px-6">{children}</div>
  </div>
);

const AdminSettingsPage: React.FC = () => {
  return (
    <AdminLayout title="Nastavení">
      <div className="space-y-6">
        <Section icon={faRobot} title="AI extrakce" subtitle="Provider, který analyzuje příchozí zprávy">
          <InfoRow label="Aktivní provider" value="Anthropic Claude (Haiku 4.5)" />
          <InfoRow label="Prompt cache TTL" value="1 hodina" />
          <InfoRow label="Záložní provider" value="OpenAI gpt-4o-mini" />
          <InfoRow label="Konfigurace" value="env vary v reservare-be Secret" muted />
        </Section>

        <Section icon={faComments} title="WhatsApp" subtitle="Meta Cloud API webhook">
          <InfoRow label="Webhook URL" value="/services/reservare-be/webhooks/whatsapp" />
          <InfoRow label="Auto-reply" value="Aktivní (text z WHATSAPP_AUTOREPLY_TEXT)" />
          <InfoRow label="Notifikace e-mail" value="env WHATSAPP_NOTIFY_EMAIL" muted />
        </Section>

        <Section icon={faEnvelope} title="E-mail (Mailjet)" subtitle="Tranzakční e-maily a notifikace">
          <InfoRow label="From" value="no-reply@reservare.cz" />
          <InfoRow label="Sandbox" value="vypnut" />
        </Section>

        <Section icon={faShieldHalved} title="Auth & Sessions" subtitle="BFF cookie session">
          <InfoRow label="Cookie" value="RESERVARE_SESSION (HttpOnly, Secure, SameSite=Lax)" />
          <InfoRow label="Default session timeout" value="30 min" />
          <InfoRow label="Remember-me" value="7 dní" />
          <InfoRow label="Session store" value="In-memory (single replica)" muted />
        </Section>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-blue-800">
          Konfigurace je read-only. Změny dělej úpravou env vars v ArgoCD repo
          (<code className="font-mono text-xs">gitops/production/*-secret.yaml</code>).
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminSettingsPage;
